/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// platform_console_admin_ui/src/api/documents.js

import { api } from "../api";

export async function saveDocumentDraft(document) {
  const response = await api.post("/documents/drafts", {
    document,
    change_source: "manual_save",
    change_summary: document.change_summary ?? null,
  });

  return response.data;
}

export async function getLatestDocument(documentType, referenceId) {
  const response = await api.get(
    `/documents/by-reference/${documentType}/${referenceId}`
  );

  return response.data;
}

export async function commitDocument(documentId, payload) {
  const response = await api.post(`/documents/${documentId}/commits`, payload);
  return response.data;
}

export async function getDocumentHistory(documentId) {
  const response = await api.get(`/documents/${documentId}/history`);
  return response.data;
}

export async function finalizeDocument(documentId, payload) {
  const response = await api.post(`/documents/${documentId}/finalize`, payload);
  return response.data;
}